import * as types from './constants';

const initialState = {
    sessionId: null,
    status: null,
    originalText: '',
    editedText: '',
    correctedText: '',
    observations: '',
    inputType: 'text',
    mappedFields: [],
    unfilledFields: [],
    processingResult: null,
    isCreating: false,
    isProcessing: false,
    isCorrecting: false,
    isApplying: false,
    isDialogOpen: false,
    error: null,
    freeModeTemplates: [],
    loadingFreeModeTemplates: false,
    freeModeTemplatesError: null,
    selectedFreeModeTemplate: null,
};

const transcriptionReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.TRANSCRIPTION_SESSION_CREATE_REQUEST:
            return {
                ...state,
                isCreating: true,
                error: null,
            };
        case types.TRANSCRIPTION_SESSION_CREATE_SUCCESS:
            return {
                ...state,
                isCreating: false,
                sessionId: action.payload.sessionId,
                status: action.payload.status,
                originalText: action.payload.originalText,
                inputType: action.payload.inputType,
            };
        case types.TRANSCRIPTION_SESSION_CREATE_ERROR:
            return {
                ...state,
                isCreating: false,
                error: action.payload,
            };

        case types.TRANSCRIPTION_UPDATE_TEXT_REQUEST:
            return {
                ...state,
                error: null,
            };
        case types.TRANSCRIPTION_UPDATE_TEXT_SUCCESS:
            return {
                ...state,
                editedText: action.payload.editedText,
            };
        case types.TRANSCRIPTION_UPDATE_TEXT_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        case types.TRANSCRIPTION_PROCESS_REQUEST:
            return {
                ...state,
                isProcessing: true,
                error: null,
            };
        case types.TRANSCRIPTION_PROCESS_SUCCESS:
            return {
                ...state,
                isProcessing: false,
                mappedFields: action.payload.mappedFields || [],
                unfilledFields: action.payload.unfilledFields || [],
                observations: action.payload.observations || '',
                processingResult: action.payload.processingResult,
            };
        case types.TRANSCRIPTION_PROCESS_ERROR:
            return {
                ...state,
                isProcessing: false,
                error: action.payload,
            };

        case types.TRANSCRIPTION_APPLY_REQUEST:
            return {
                ...state,
                isApplying: true,
                error: null,
            };
        case types.TRANSCRIPTION_APPLY_SUCCESS:
            return {
                ...state,
                isApplying: false,
                status: 'completed',
            };
        case types.TRANSCRIPTION_APPLY_ERROR:
            return {
                ...state,
                isApplying: false,
                error: action.payload,
            };

        case types.TRANSCRIPTION_GET_SESSION_REQUEST:
            return {
                ...state,
                error: null,
            };
        case types.TRANSCRIPTION_GET_SESSION_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        case types.TRANSCRIPTION_GET_SESSION_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        case types.TRANSCRIPTION_AUDIO_UPLOAD_REQUEST:
            return {
                ...state,
                isProcessing: true,
                error: null,
            };
        case types.TRANSCRIPTION_AUDIO_UPLOAD_SUCCESS:
            return {
                ...state,
                isProcessing: false,
                originalText: action.payload.data?.text || action.payload.text,
            };
        case types.TRANSCRIPTION_AUDIO_UPLOAD_ERROR:
            return {
                ...state,
                isProcessing: false,
                error: action.payload,
            };

        case types.TRANSCRIPTION_CORRECT_TEXT_REQUEST:
            return {
                ...state,
                isCorrecting: true,
                error: null,
            };
        case types.TRANSCRIPTION_CORRECT_TEXT_SUCCESS:
            return {
                ...state,
                isCorrecting: false,
                correctedText: action.payload.correctedText || action.payload,
            };
        case types.TRANSCRIPTION_CORRECT_TEXT_ERROR:
            return {
                ...state,
                isCorrecting: false,
                error: action.payload,
            };

        case types.TRANSCRIPTION_RESET:
            return initialState;

        case types.TRANSCRIPTION_DIALOG_OPEN:
            return {
                ...state,
                isDialogOpen: true,
                formStructure: action.payload?.formStructure || null,
                formId: action.payload?.formId || null,
                contextInfo: action.payload?.contextInfo || null,
            };
        case types.TRANSCRIPTION_DIALOG_CLOSE:
            return {
                ...state,
                isDialogOpen: false,
            };

        case types.TRANSCRIPTION_FETCH_FREE_MODE_TEMPLATES_REQUEST:
            return {
                ...state,
                loadingFreeModeTemplates: true,
            };
        case types.TRANSCRIPTION_FETCH_FREE_MODE_TEMPLATES_SUCCESS:
            return {
                ...state,
                loadingFreeModeTemplates: false,
                freeModeTemplates: action.payload,
            };
        case types.TRANSCRIPTION_FETCH_FREE_MODE_TEMPLATES_ERROR:
            return {
                ...state,
                loadingFreeModeTemplates: false,
                freeModeTemplatesError: action.payload,
            };
        case types.TRANSCRIPTION_SET_SELECTED_TEMPLATE:
            return {
                ...state,
                selectedFreeModeTemplate: action.payload,
            };
        case types.TRANSCRIPTION_CLEAR_SELECTED_TEMPLATE:
            return {
                ...state,
                selectedFreeModeTemplate: null,
            };

        case types.TRANSCRIPTION_CLEAR_PENDING:
            return {
                ...state,
                pendingApplyFields: null,
                pendingObservations: null,
                pendingRawContent: null,
            };

        default:
            return state;
    }
};

export default transcriptionReducer;
